import styled from 'styled-components'

import * as colors from '../../constants/colors'
import * as input from '../form/input'

export const ColorDisplay = styled.div<{ color: string; size?: number }>`
  background-color: ${(props) => props.color};
  border-radius: 50%;
  border: 1px solid ${colors.GREY_SHADE_5};
  box-sizing: border-box;
  cursor: pointer;
  flex: none;
  height: ${(props) => props.size ?? 50}px;
  margin-right: 11px;
  width: ${(props) => props.size ?? 50}px;

  input[type='color'] {
    border: none;
    cursor: pointer;
    display: block;
    height: 50px;
    opacity: 0;
    width: 50px;
  }
`

export const Container = styled.div`
  width: fit-content;
  display: flex;
`

export const InputWrapper = styled(input.ComposedWrapper)`
  height: 50px;

  ${input.Input} {
    width: 80px;
    padding-left: 0;
  }
`
